(() => {
  if (window.aorakiModelRotationLoaded) return;
  window.aorakiModelRotationLoaded = true;

  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  const shuffle = (items) => {
    for (let i = items.length - 1; i > 0; i -= 1) {
      const random = window.crypto?.getRandomValues
        ? window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296
        : Math.random();
      const j = Math.floor(random * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };

  const rotate = () => {
    if (new URLSearchParams(window.location.search).has('sort_by')) return;
    const grid = container.querySelector('ul.product-grid');
    if (!grid) return;
    const cards = Array.from(grid.children).filter((node) => node.matches('li[data-product-id]'));
    if (cards.length < 2 || grid.dataset.modelRotationCount === String(cards.length)) return;

    const groups = new Map();
    for (const card of cards) {
      const key = card.dataset.modelKey || card.dataset.productId;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(card);
    }

    const models = shuffle(Array.from(groups.values()));
    for (const variants of models) shuffle(variants);
    const ordered = [];
    const rounds = Math.max(...models.map((variants) => variants.length));
    for (let round = 0; round < rounds; round += 1) {
      for (const variants of models) {
        if (variants[round]) ordered.push(variants[round]);
      }
    }

    grid.dataset.modelRotationCount = String(cards.length);
    grid.append(...ordered);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      rotate();
    });
  };
  new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();